import { NumberScaleRating, Row } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { EvaluatedFeedbackNumberRatingQuestionResource } from "../types/feedback";

const StyledRow = styled(Row)`
	align-items: start;
	padding-top: ${({ theme }) => theme.spacing(3)};
`;

interface Props {
	question: EvaluatedFeedbackNumberRatingQuestionResource;
}
export const CompactFeedbackNumberRatingQuestionEvaluation: FC<Props> = ({ question }) => {
	return (
		<StyledRow $columnGap={8}>
			<span>⌀ {question.evaluation.averageRating.toFixed(1)}</span>
			<NumberScaleRating rating={question.evaluation.averageRating} />
		</StyledRow>
	);
};
